
<p-toggleButton offLabel="Leaf level only" onLabel="Show hierarchy"
offIcon="pi pi-list" onIcon="pi pi-sitemap" [(ngModel)]="toggleLeavesOnly" (onChange)="changeToggleLeavesOnly()"></p-toggleButton>
<p-treeTable
#tree
[loading]="loadingAccounts"
[value]="accounts"
[columns]="cols"
dataKey="id"
[contextMenu]="cm"
contextMenuSelectionMode="joint"
[scrollable]="true" scrollHeight="300px"
[selectionMode]="this.selectionMode"
[(selection)]="this.selected"
(onNodeUnselect)="unselectNode($event)"
(onNodeSelect)="onNode()"
(onNodeExpand)="onNodeExpand($event)"
>
<ng-template pTemplate="caption">
    <input type="text" pInputText placeholder="Search..." (input)="tree.filterGlobal($event.target.value, 'contains')" (keyup.enter)="transferOnEnter()" class="search-accounts-input" [(ngModel)]="searchValue">
</ng-template>

<ng-template pTemplate="header">
    <tr>
        <th style="width: 15% !important;">Code</th>
        <th style="width: 35% !important;">Row #</th>
        <th style="width: 50% !important;">Name</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
        <td style="width: 15% !important; word-wrap: break-word;" [ngStyle]="{'background': rowData.leaf ? '#8BC34A' : 'inherit','color': rowData.leaf ? '#fff' : 'inherit'}">
            <p-treeTableToggler [rowNode]="rowNode">
            </p-treeTableToggler>
            {{rowData.code}}
        </td>
        <td style="width: 35% !important; word-wrap: break-word;" [ngStyle]="{'background': rowData.leaf ? '#8BC34A' : 'inherit','color': rowData.leaf ? '#fff' : 'inherit'}">
            {{rowData.lineNumbers}}
            <!--<span pTooltip="{{rowData.lineNumbersExtended}}" tooltipStyleClass="lineNumbersTooltip" tooltipPosition="top">{{rowData.lineNumbers}}</span>-->
        </td>
        <td style="width: 50% !important; word-wrap: break-word;" [ngStyle]="{'background': rowData.leaf ? '#8BC34A' : 'inherit','color': rowData.leaf ? '#fff' : 'inherit'}">
            {{rowData.name}}
        </td>
    </tr>
</ng-template>

<!--<ng-template pTemplate="colgroup" let-columns>
<colgroup>
    <col *ngFor="let col of tableColumns" [style.width]="col.width">
</colgroup>
</ng-template>-->
<ng-template pTemplate="emptymessage">
<tr>
    <td [attr.colspan]="cols.length">No data found.</td>
</tr>
</ng-template>
</p-treeTable>
<p-contextMenu #cm [model]="items" appendTo="body"></p-contextMenu>
